<svg x="{{position.x}}" y="{{position.y}}">
    <g fill="none" stroke="black" stroke-width="1">
        <path d="m30 5 0 {{scaleHeight}}" stroke-width="1"/>
        {{#each ticks}}
        <path d="m30 {{position}}h15"/>
        {{/each}}
        {{#each subTicks}}
        <path d="m30 {{this}}h9"/>
        {{/each}}
    </g>
    <g fill="black" stroke="black" stroke-width=".5">
        {{#each subSubTicks}}
        <path d="m30 {{this}}h6.1"/>
        {{/each}}
    </g>
    <g font-size="8px">
        {{#each ticks}}
        <text x="25" y="{{textPosition}}" text-anchor="end">
            {{text}}
        </text>
        {{/each}}
    </g>
</svg>
